import React from 'react';
import { bool, string } from 'prop-types';
import { Alert, Link } from '@one-thd/sui-atomic-components';
import { signIn } from '../../../helper';
import { MAP_POLICY_VERBIAGE, MAP_POLICY_RANK } from '../../../constants';
import '../shared-summary.scss';

export const Messaging = ({ mapExists, mapPolicy, isCustomerIdentified }) => {
  return (
    <>
      {(mapExists) && (
        <Alert status="info">
          {mapPolicy ? (
            <>
              {MAP_POLICY_VERBIAGE[!isCustomerIdentified ? mapPolicy : MAP_POLICY_RANK.SHOW_PRICE_IN_CART]}
              {(!isCustomerIdentified && mapPolicy === MAP_POLICY_RANK.SHOW_SPECIAL_PRICE_IF_AUTH) && (
                <>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <Link component="button" onClick={signIn}>Sign in for The Home Depot price</Link>
                </>
              )}
            </>
          ) : (
            MAP_POLICY_VERBIAGE.showPriceInCart
          )}
        </Alert>
      )}
    </>
  );
};

Messaging.propTypes = {
  mapExists: bool.isRequired,
  mapPolicy: string.isRequired,
  isCustomerIdentified: bool.isRequired
};
